/* eslint-disable max-lines */
/* eslint-disable no-unused-vars */
import FileSaver from 'file-saver';
import errorTransformer from '../shared/transformers/errorTransformer';
import requests from './requests';
import transformCampaignOverallStats from './transformers/transformCampaignOverallStats';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';
import transformPackageDailyStats from './transformers/transformPackageDailyStats';
import transformReportDailyStats from './transformers/transformReportDailyStats';

async function saveXlsxFile(response) {
  const contentDisposition =
    response?.headers?.map?.['content-disposition']?.[0];
  const fileName = contentDisposition.split('filename=')[1]?.split(';')[0];
  const blob = await response.blob();
  FileSaver.saveAs(blob, fileName);
}

export function getCampaigns({
  packageName,
  page,
  pageSize,
  campaignIds,
} = {}) {
  return requests
    .getCampaigns({
      package_name: packageName,
      page,
      page_size: pageSize,
      campaign_ids: campaignIds || undefined,
    })
    .then(response => transformToCamelCase(response.data || []))
    .catch(errorTransformer);
}

export function getCampaignData(uuid) {
  return requests
    .getCampaignData(uuid)
    .then(response => transformToCamelCase(response.data))
    .catch(errorTransformer);
}

export function updateCampaign(id, data) {
  return requests
    .updateCampaign(id, data)
    .then(response => response.data)
    .catch(errorTransformer);
}

export function getPackageDailyStats({ packageName, start, end } = {}) {
  return requests
    .getPackageDailyStats({ package_name: packageName, start, end })
    .then(response => transformPackageDailyStats(response.data))
    .catch(errorTransformer);
}

export function downloadOverviewStats({ packageName, start, end } = {}) {
  return requests
    .exportPackageDailyStats({
      package_name: packageName,
      start,
      end,
      export: true,
    })
    .then(saveXlsxFile)
    .catch(errorTransformer);
}

export function downloadCampaignsDailyReport({
  packageName,
  start,
  end,
  campaignIds,
} = {}) {
  return requests
    .exportCampaignsDailyStats({
      package_name: packageName,
      start,
      end,
      campaign_ids: campaignIds,
      export: true,
    })
    .then(saveXlsxFile)
    .catch(errorTransformer);
}

export function getCampaignsDailyStats({
  packageName,
  campaignIds = [],
  start,
  end,
}) {
  return requests
    .getCampaignsDailyStats({
      package_name: packageName,
      start,
      end,
      campaign_ids: campaignIds,
    })
    .then(response => transformReportDailyStats(response.data))
    .catch(errorTransformer);
}

export function getReportOverallStats({
  packageName,
  start,
  end,
  campaignIds,
  pageSize,
} = {}) {
  return requests
    .getCampaignsOverallStats({
      package_name: packageName,
      start,
      end,
      campaign_ids: campaignIds,
    })
    .then(response => {
      const { stats, campaigns } = transformToCamelCase(response.data);
      const ratioCharts = [
        stats.installsToImpressionsRatio,
        stats.installsToViewsRatio,
        stats.viewsToImpressionsRatio,
      ];
      const pieCharts = [
        stats.installs,
        stats.impressions,
        stats.views,
        stats.cost,
        stats.avgCost,
      ];
      const campaignsStats = transformCampaignOverallStats(response.data);
      return { ratioCharts, pieCharts, campaignsStats };
    })
    .catch(errorTransformer);
}

export function getCampaignsOverallStats({
  packageName,
  start,
  end,
  campaignIds,
  pageSize,
  page,
} = {}) {
  return requests
    .getCampaignsOverallStats({
      package_name: packageName,
      start,
      end,
      campaign_ids: campaignIds,
      pageSize,
      page,
    })
    .then(response => transformCampaignOverallStats(response.data))
    .catch(errorTransformer);
}

export function getKeywordsStats({ packageName, start, end, campaignIds }) {
  return requests
    .getKeywordsStats({
      package_name: packageName,
      start,
      end,
      campaign_ids: campaignIds,
    })
    .then(response => transformToCamelCase(response.data))
    .catch(errorTransformer);
}

export function downloadKeywordsStats({
  packageName,
  start,
  end,
  campaignIds,
} = {}) {
  return requests
    .exportKeywordsStats({
      package_name: packageName,
      start,
      end,
      campaign_ids: campaignIds,
      export: true,
    })
    .then(saveXlsxFile)
    .catch(errorTransformer);
}
